export function setTheme(themeName: string) {
  localStorage.setItem('theme', themeName);
  document.documentElement.className = themeName;
  let darkPath: string = '/tailwind-dark.css';
  let smallDarkPath: string = '/tailwind-dark-small.css';
  let lightPath: string = '/tailwind-light.css';
  let smallLightPath: string = '/tailwind-light-small.css';
  var link: HTMLElement | null = document.getElementById('theme-color');
  if (themeName === 'theme-dark') {
    link?.setAttribute('href', darkPath);
  } else if (themeName === 'theme-light') {
    link?.setAttribute('href', lightPath);
  } else if (themeName === 'theme-dark-small') {
    link?.setAttribute('href', smallDarkPath);
  }else if (themeName === 'theme-light-small') {
    link?.setAttribute('href', smallLightPath);
  }
}